import { Question, UserAnswer } from '../../../../../data/models'
import { IQuestionCorrectnestStrategy } from '..'

export class AnswerValueCorrectnessStrategy implements IQuestionCorrectnestStrategy {
  public isCorrect(question: Question, userAnswers: UserAnswer[]): boolean {
    const validChoices = question.answerChoices.filter((choice) => choice.value !== undefined && choice.value !== '')
    return validChoices.every((choice) => {
      const userAnswer = userAnswers.find((userAnswer) => choice.id === userAnswer.answerChoice.id)
      return !!userAnswer && choice.value === userAnswer.value
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/question-correctness/correctness-strategies/answer-value-correctness-strategy/answer-value-correctness-strategy.ts